<template>
    <section class="section-video light--bg-blue">
        <div class="row max-width-md section-title pb-3 pt-6">
            <video-empresa />
        </div>
    </section>
</template>
<script>
import VideoEmpresa from '@/components/layout/video-empresa.vue';

export default {
    name:'SectionVideoEmpresa',
    components: {
        VideoEmpresa
    }
}
</script>
<style lang="scss" scoped>
.section-video {
    padding-bottom:40px;

    .page-title {
        padding-bottom:0px;
        padding-top: 30px;
    }

    .section-title {
        @media (max-width: 549px) {
            padding-right: 1rem;
            padding-left: 1rem;
        }
    }
}
</style>